angular.module('app').directive('orderTable', function() {
    return {
        'scope': {
            'orders': '=',
        },
        'template': `
            <div>
                <span data-ng-show="orders.length == 0">No orders</span>
                <md-table-container>
                <table data-ng-show="orders.length > 0 "md-table>
                    <thead md-head>
                        <tr md-row>
                            <th md-column>Id</th>
                            <th md-column>Date</th>
                            <th md-column>Status</th>
                            <th md-column>Total</th>
                        </tr>
                    </thead>
                    <tbody md-body>
                        <tr md-row data-ng-repeat="order in orders">
                            <td md-cell>
                                <a href="#/order/{{ order.id }}">{{ order.id }}</a>
                            </td>
                            <td md-cell>{{ order.created_at | date:'short' }}</td>
                            <td md-cell>{{ order.status }}</td>
                            <td md-cell>\${{ order.total | money }}</td>
                        </tr>
                    </tbody>
                </table>
                </md-table-container>
            </div>
        `
    };
});
